import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "htmlExtract",
  "name": "HTML Extract",
  "category": "utilities",
  "description": "Extract data from HTML using CSS selectors",
  "icon": "FileSearch",
  "color": "orange",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "HTML Extract",
    "color": "#f97316"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "html",
    "extract",
    "parse",
    "scrape",
    "css-selector"
  ],
  "comingSoon": false
};

export default definition;
